import React from 'react';

export interface ITabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  className?: string;
  positionAbsolute?: boolean;
  maxHeight?: boolean;
  maxWidth?: boolean;
}

// Example:
// <TabPanel value={this.state.tabIndex} index={0}>
//   <p>Hello</p>
// </TabPanel>

export function TabPanel(props: ITabPanelProps) {
  const { children, value, index, className, positionAbsolute, maxHeight, maxWidth, ...other } =
    props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className={className}
      {...other}
      style={{
        position: positionAbsolute ? 'absolute' : 'relative',
        height: maxHeight ? '100%' : 'auto',
        width: maxWidth ? '100%' : 'auto',
      }}
    >
      {value === index && children}
    </div>
  );
}

export function MakeTabProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
